<template>
    <div class="left">
        <div class="left_box">
            <div class="box_bg2"
                 v-if="taskType==1 || testType==4">
                <div class="left_box-div3">
                    <p>{{finish}}人</p>
                    <p>已完成</p>
                </div>
                <div class="left_box-div3">
                    <p>{{unfinish}}人</p>
                    <p>未完成</p>
                    <p :class="{'disabled_btn':!finishlist.length}"
                       @click="cuicu(0,unfinish)">催促</p>
                </div>
            </div>
            <div class="box_bg2"
                 v-else>
                <!-- <div :class="[is_active?'box_bg1':'box_bg2']"  v-else> -->
                <!-- <div :class="is_active?'left_box-div1':'left_box-div2'">
                    <p>{{finish}}人</p>
                    <p>已完成</p>
                </div> -->
                <div :class="is_active?'left_box-div3':'left_box-div2'">
                    <p>{{finish}}人</p>
                    <p>已完成</p>
                </div>
                <div :class="is_active?'left_box-div3':'left_box-div2'">
                    <p>{{unfinish}}人</p>
                    <p>未完成</p>
                    <p :class="{'disabled_btn':!finishlist.length}"
                       @click="cuicu(0,unfinish,0)">催促</p>
                </div>
                <div class="left_box-div2"
                     v-if="!is_active">
                    <p>{{unspec}}人</p>
                    <p>未个性化学习</p>
                    <p :class="{'disabled_btn':!finishlist.length}"
                       @click="cuicu(1,unspec,unfinish)">催促</p>
                </div>
                <div :class="is_active?'left_box-div1':'left_box-div2'"
                     v-if="!is_active">
                    <p>{{wrong_num}}人</p>
                    <p>未订正</p>
                    <p :class="{'disabled_btn':!finishlist.length}"
                       @click="revision()">催促</p>
                </div>
            </div>
        </div>
        <div class="list">
            <div class="list_box">
                <div class="list_title">
                    <p>学生情况</p>
                    <div v-if='testType!=4&&!is_active'
                         class='list_box-tips'></div>
                    <!-- <p @click="news" v-if="city!=411600">写评语</p> -->
                </div>
            </div>
            <div class="lists">
                <div>
                    <p class="name">姓名</p>
                    <p class="score"
                       v-if="taskType==1">状态</p>
                    <p class="score"
                       v-else>成绩</p>
                    <p class="upTime">提交时间</p>
                </div>
            </div>
            <div v-if="finishlist.length">
                <div class="lists1"
                     v-for="i in finishlist">
                    <div v-if="i.status != '0'"
                         @click="toMywork(i)">
                        <p>
                            <span class="user_name">{{i.real_name}}</span>
                            <i class="tig-bu"
                               v-if="i.status== 2&&!is_active">补</i>
                        </p>
                        <p v-if="taskType!=1"><i>{{i.score}}分</i> <em v-if="i.wrong_status&&i.score<100&&testType!=4&&!is_active"
                                class="p_revision"></em></p>
                        <p v-else><i>已完成</i></p>
                        <p class="no">{{i.test_date}}
                            <span v-if="taskType!=1"
                                  class="zhankai"
                                  @click="toMywork(i)"></span>
                        </p>
                    </div>
                    <div v-else>
                        <p>{{i.real_name}}</p>
                        <p>未完成</p>
                        <p class="no">-&nbsp;-</p>
                    </div>
                </div>
            </div>
            <div class="noresources"
                 v-else>
                <p>当前班级暂无学生</p>
            </div>
        </div>
        <div id="layui-m-layer"
             class="layui-m-layer layui-m-layer0"
             v-if='urge'>
            <div class="layui-m-layershade"></div>
            <div class="layui-m-layermain">
                <div class="layui-m-layersection">
                    <div class="layui-m-layerchild  layui-m-anim-scale">
                        <div class="title_container">
                            <span @click="send_qun"
                                  :class="{'title_on':send_Type=='qun'}"
                                  class="lay_title lay_title1">发到家长群</span>
                            <span @click="send_msg"
                                  :class="{'title_on':send_Type=='msg'}"
                                  class="lay_title lay_title2"
                                  v-if="platform_id=='410000'">发送短信<span class="title_tip">（仅发送开通用户）</span></span>
                        </div>
                        <textarea class="textar"
                                  v-bind:maxlength="200"
                                  ref="textar"
                                  @input="info1"
                                  v-model='information1'></textarea>
                        <div class="layui-m-layerbtn">
                            <span @click='cancel'>取消</span>
                            <span @click='release'
                                  v-if="send_Type=='qun'">发到家长群里</span>
                            <span @click='release2'
                                  v-if="send_Type=='msg'">发送短信</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="layui-m-layer1"
             class="layui-m-layer layui-m-layer0"
             v-if='hd_layer'>
            <div class="layui-m-layershade"></div>
            <div class="layui-m-layermain">
                <div class="layui-m-layersection">
                    <div class="layui-m-layerchild  layui-m-anim-scale">
                        <p style='text-align:left;padding:0.75rem 0.75rem 0.4rem;font-size:0.75rem;color:#333;'>发到家长群</p>
                        <textarea class="textar"
                                  v-bind:maxlength="200"
                                  ref="textar"
                                  @input="info1"
                                  v-model='information1'></textarea>
                        <div class="layui-m-layerbtn">
                            <span @click='cancel'>取消</span>
                            <span @click='release'>发到家长群</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
export default {
    props: ['finishlist', 'taskType', 'testType', "finish", "unfinish", "unspec", "city", "taskid", "classid", "sid", 'endDate', "wrong_num"],
    data () {
        return {
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            send_Type: 'qun',//msg发送短信，qun发送到群
            cuicuType: "",
            urge: false,
            information1: '同步课堂已为你专属生成了个性化学习，请登录app，进入12月12日的作业，点击个性化学习，进行训练',
            type: null,
            tbkt_Token: localStorage.getItem("Tbkt-Token"),
            city_id: localStorage.getItem('city_id'),
            platform_id: localStorage.getItem('platform_id'),
            is_active: Number(this.$route.query.is_active) || 0, //寒假活动
            isSend: true,//防止连点
            hd_layer: false,
            type: 1,//  type 1 催促未做完 2 催促个性化学习 3 催促错题订正
            is_edit: 0,
            task_name: this.$route.query.task_name,
            begin_date: this.$route.query.begin_date,
            mid: this.$route.query.mid || "",
            informationObj: {},
            sms_id: 0,
        }
    },
    computed: {
        level () {
            return this.$store.state.winterlevel
        }
    },
    created () {
        this.informationObj = {
            0: [//未完成
                `（${this.getSmsdate(this.begin_date)}）数学的${this.task_name}作业以下孩子未完成，请尽快督促孩子完成。`,
                '',//接口获取
            ],
            1: [//未个性化学习
                '已为你专属生成了个性化学习，请登录app，进入' + this.endDate.split('日')[0] + '日的作业，点击个性化学习，进行训练。',
                '',
            ],
            2: [//未订正
                `（${this.getSmsdate(this.begin_date)}）数学的${this.task_name}作业以下孩子未完成错题订正，请尽快督促孩子完成订正。`,
                '',//接口获取
            ]
        }
        if (this.testType == 2 || this.testType == 3) {
            let title = `同步课堂`;
            if (this.city_id == "411600") {
                title = "随堂练";
            }
            this.information1 = title + this.informationObj[1][0];
        } else {
            this.information1 = this.information1 = this.informationObj[0][0];
        }
    },
    methods: {
        getSmsContent (title) {
            this.$store.dispatch('urge_content', {
                'sid': this.sid,
                'task_type': this.task_name,
                'begin_date': Number(this.begin_date),
                'type': this.type + 1
            }).then((res) => {
                let _res = res.data.data;
                this.sms_id = _res.sms_id;
                this.informationObj[this.type][1] = _res.content;
                this.information1 = this.informationObj[this.type][0];
                if (this.type == 1 && this.send_Type == 'msg') {
                    this.information1 = title + this.informationObj[this.type][0];
                }
                this.is_edit = 0;
                this.urge = !this.urge;
            })
        },
        revision () {
            this.send_Type = 'qun';
            if (this.finishlist.length) {
                if (Number(this.wrong_num)) {
                    this.type = 2;
                    this.getSmsContent();
                } else {
                    layer.tips('所有学生都已完成');
                }
            }
        },
        toMywork (ts) {//个人作业详情
            ////console.log(ts)
            if (this.taskType == 1) {
                return
            }
            if (this.testType != 4) {
                this.$router.push('/mytask/' + this.sid + '/' + this.classid + '/' + this.taskid + '/' + ts.user_id + '/' + ts.real_name + "?score=" + ts.score + "&is_active=" + this.is_active)
            } else {
                this.$router.push('/mytask/quick/' + this.sid + '/' + this.classid + '/' + this.taskid + '/' + ts.user_id + '/' + ts.real_name + "?score=" + ts.score)
            }

        },
        send_qun () {
            this.send_Type = 'qun'
            this.information1 = this.informationObj[this.type][0];
        },
        send_msg () {
            this.send_Type = 'msg'
            this.information1 = this.informationObj[this.type][1];
        },
        cuicu (type, num, num2) {
            if (this.is_active) {//活动催促
                if (num == 0) {
                    layer.tips('所有学生都已完成');
                    return false;
                }
                this.information1 = this.is_active == 2 ? "家长您好！为了让孩子度过一个充实的寒假，我为孩子推荐了一份“寒假作业”，其中包含了知识复习和新课预习，帮助孩子巩固学习，更加从容的步入新学期。" : "家长您好！为了让孩子度过一个充实的暑假，我为孩子推荐了一份“暑假作业”，其中包含了知识复习和新课预习，帮助孩子巩固学习，更加从容的步入新学期。"
                this.hd_layer = true;
                return false;
            }
            if (this.finishlist.length) {
                this.send_Type = 'qun'
                // //console.log(type)
                ////console.log(Number(num))
                if (type == 0) {//催促    num未完成作业人数
                    this.cuicuType = 0
                    if (Number(num)) {
                        this.type = type;
                        let title = ``;
                        if (type) {
                            title = `同步课堂`;
                            if (this.city_id == "411600") {
                                title = "随堂练";
                            }
                        }
                        this.getSmsContent(title);
                    } else {
                        layer.tips('所有学生都已完成');
                    }
                } else {//个性化学习催促 type==1  num未个性化人数  num2 未完成作业人数
                    this.cuicuType = 1
                    if (Number(num)) {//未个性化人数不为0
                        this.type = type;
                        let title = ``;
                        if (type) {
                            title = `同步课堂`;
                            if (this.city_id == "411600") {
                                title = "随堂练";
                            }
                        }
                        this.getSmsContent(title);
                    } else {//未个性化人数为0，
                        if (num2) {//未完成作业人数不为0
                            layer.tips('还有' + num2 + '名学生未完成作业');
                        } else {//未完成作业人数为0
                            layer.tips('所有学生都已完成');
                        }
                    }
                }
            }
        },
        info1 () {
            var textVal = this.information1.length;
            if (this.send_Type == 'msg') {
                this.is_edit = 1;
            }

            if (this.information1.length >= 200) {
                layer.tips('已经超过200字了')
            }
        },
        // news() { //一键写评语
        //this.$router.push('/sx/task/classdetail/new_common/' + this.taskid + '/' + this.classId)
        // },
        cancel () {
            this.is_edit = 0;
            this.hd_layer = false;
            this.urge = false;
        },
        release2 () {//发送短信
            if (!this.isSend) {
                return false;
            }
            this.isSend = false;
            let this_ = this
            let stu_user_id = [];

            this.finishlist.forEach(item => {
                if (item.status == 0 && this.type != 2) {
                    stu_user_id.push(item.user_id);
                }
                if (item.score < 100 && item.wrong_status && this.type == 2) {
                    stu_user_id.push(item.user_id);
                }
            })
            if (this.type == 0 || this.type == 2) {//点击的是催促
                let { real_name } = JSON.parse(localStorage.getItem('info'));
                // let content = this.informationObj[this.type][1];
                this.$http.post(API_URL_TASK_API + '/public/task/urge', {
                    message_id: this_.taskid,
                    unit_class_id: this_.classid,
                    sid: this_.$route.params.sid,
                    stu_user_id: stu_user_id.join(','),
                    type: this.type ? 3 : 1,
                    content: this.information1,
                    task_type: this.task_name,
                    begin_date: Number(this.begin_date),
                    is_edit: this.is_edit,
                    sms_id: this.sms_id,
                    place_id: this.type ? 31 : 30,//配置平台发送短信配置参数
                }).then(res => {
                    this.isSend = true;
                    if (res.data.response == 'ok') {
                        this_.urge = false;
                        layer.tips("发送成功！");
                    } else {
                        layer.tips("发送失败！");
                    }
                })
            } else {//点击的是未个性化学习的催促
                // //console.log('gexinghua')
                this.$http.post(API_URL_TASK_API + '/public/task/urge', {
                    message_id: this_.taskid,
                    unit_class_id: this_.classid,
                    sid: this_.$route.params.sid,
                    type: 2,
                    content: this.information1,
                    task_type: this.task_name,
                    begin_date: Number(this.begin_date),
                    is_edit: this.is_edit,
                    sms_id: this.sms_id,
                    place_id: 32,//配置平台发送短信配置参数
                }).then(res => {
                    this.isSend = true;
                    if (res.data.response == 'ok') {
                        this_.urge = false;
                        layer.tips("发送成功！");
                    } else {
                        layer.tips("发送失败！");
                    }
                })
            }
        },
        release () {//发送到群里
            let that=this
            if (!this.isSend) {
                return false;
            }
            this.isSend = false;
            this.information1 = this.information1.replace(/(^\s*)|(\s*$)/g, "");
            this.information1 = this.information1.replace(/,/g, '，');
            if (this.information1.length > 200) {
                layer.tips('已经超过200字了');
                return false
            } else if (this.information1 == 0) {
                layer.tips('内容为空');
                return false
            }
            let data = {
                message_id: this.taskid,
                unit_class_id: this.classid,
                content: this.information1,
                type: this.type
            }
            this.$http.post(API_URL_TASK_API + '/public/task/tea/share/in', data).then(res => {
                this.isSend = true;
                if (res.data.response == 'ok') {
                    this.cancel();
                    let id = res.data.data.id;
                    let content = res.data.data.content;
                    let url = VUE_URL_HD;
                    let sid = this.$route.params.sid;
                    let place = "教师检查作业催促发送到群里";
                    if (this.is_active) {//活动
                        let title = `同步课堂`;
                        content = this.is_active == 2 ? "寒假作业完成情况，请家长注意查看！" : "暑假作业完成情况，请家长注意查看！"
                        url += this.is_active == 2 ? `/#/winter2020/tea/sharePreview?subject_id=${sid}&unit_class_id=${this.classid}&message_id=${this.mid ? this.mid : this.taskid}&level=${this.level}&tbkt_token=${this.tbkt_Token}` : `/#/summer2020/taskShare?sid=${sid}&unit_class_id=${this.classid}&message_id=${this.taskid}&level=${this.level}&tbkt_token=${this.tbkt_Token}`;
                        place = this.is_active == 2 ? "寒假活动教师检查作业催促发送到群里" : "暑假活动教师检查作业催促发送到群里";
                        this.appFunction("ys_share", `${title},${content},${url},${sid},${this.classid},0,4,${place}`);
                        return false;
                    }
                    if (this.type == 2) {
                        url += `/#/share/wrongTask?sid=${sid}&unit_class_id=${this.classid}&message_id=${this.taskid}&id=${id}&tbkt_token=${this.tbkt_Token}`;
                    } else {
                        url += `/#/share/examine_task?sid=${sid}&type=${this.type}&id=${id}&tbkt_token=${this.tbkt_Token}`;
                    }
                    let title = `同步课堂`;
                    if (this.city_id == "411600") {
                        title = "随堂练";
                    }
                    if(this.inApp){
                        this.appFunction("ys_share", `${title},${content},${url},${sid},${this.classid},0,0,${place}`)
                    }else{
                        let coptText=`${title},${content},链接：${url}`
                        layer.alert('将链接粘贴并发送到对应的班级群，家长点击链接即可。', 'tea', function (index) {
                            layer.close(index)
                           that.copyText(coptText);
                        }, '分享链接复制成功')
                    }
                }
            })
        },
        copyText (text) {
            const input = document.createElement('input');
            input.setAttribute('readonly', 'readonly');
            input.setAttribute('value', text);
            document.body.appendChild(input);
            input.setSelectionRange(0, 9999);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.title_container {
    width: 93.4%;
    overflow: hidden;
    margin: 0 auto;
    margin-top: 0.4rem;
}

.lay_title {
    color: #000000;
    text-align: center;
    padding: 0.25rem 0;
    float: left;
    font-size: 0.7rem;
    border-bottom: none;
    border-top-left-radius: 0.15rem;
    border-top-right-radius: 0.15rem;
    box-sizing: border-box;
}

.title_on {
    background-color: #f0f0f0;
}

.title_tip {
    color: red;
    font-size: 0.6rem;
}

.lay_title1 {
    width: 30%;
}

.lay_title2 {
    width: 70%;
}

.left {
    width: 100%;
    height: auto;
    .left_box {
        width: 100%;
        height: 239px / $ppr;
        background: #fff;
        padding-top: 23px / $ppr;
        .box_bg1 {
            width: 672px / $ppr;
            height: 238px / $ppr;
            background-size: 100%;
            margin: 0 auto;
            div {
                float: left;
                width: 216px / $ppr;
                height: 238px / $ppr;
                margin-right: 12px / $ppr;
                background: url("../img/icon_img_02.png") no-repeat;
                p {
                    width: 100%;
                }
                p:nth-child(1) {
                    height: 48px / $ppr;
                    line-height: 48px / $ppr;
                    text-align: center;
                    margin-top: 40px / $ppr;
                    color: #ff6600;
                    font-size: 48px / $ppr;
                    font-weight: bold;
                }
                p:nth-child(2) {
                    height: 24px / $ppr;
                    line-height: 24px / $ppr;
                    text-align: center;
                    margin-top: 16px / $ppr;
                    color: #999;
                    font-size: 24px / $ppr;
                }
                p:nth-child(3) {
                    text-align: center;
                    margin-top: 32px / $ppr;
                    color: #5e89ef;
                    font-size: 24px / $ppr;
                }
            }
            div:nth-child(3) {
                margin-right: 0;
            }
        }
        .box_bg2 {
            width: 671px / $ppr;
            height: 238px / $ppr;
            // background: url('../img/icon_bg2.png') no-repeat;
            background-size: 100%;
            margin: 0 auto;
            display: flex;
            display: -webkit-box;
            display: -webkit-flex;
            justify-content: space-between;
            -webkit-box-pack: justify;
            -webkit-justify-content: space-between;
            margin: 0 auto;
            div {
                float: left;
                // width: 216px/$ppr;
                height: 238px / $ppr;
                &.left_box-div1 {
                    width: 216px / $ppr;
                    background: url("../img/icon_img_01.png") no-repeat;
                    background-size: 100%;
                }
                &.left_box-div2 {
                    width: 159px / $ppr;
                    background: url("../img/icon_img_02.png") no-repeat;
                    background-size: 100%;
                }
                &.left_box-div3 {
                    width: 330px / $ppr;
                    background: url("../img/icon_img_03.png") no-repeat;
                    background-size: 100%;
                }
                p {
                    width: 100%;
                }
                p:nth-child(1) {
                    height: 48px / $ppr;
                    line-height: 48px / $ppr;
                    text-align: center;
                    margin-top: 40px / $ppr;
                    color: #ff6600;
                    font-size: 48px / $ppr;
                    font-weight: bold;
                }
                p:nth-child(2) {
                    height: 24px / $ppr;
                    line-height: 24px / $ppr;
                    text-align: center;
                    margin-top: 16px / $ppr;
                    color: #999;
                    font-size: 24px / $ppr;
                }
                p:nth-child(3) {
                    text-align: center;
                    margin-top: 32px / $ppr;
                    color: #5e89ef;
                    font-size: 24px / $ppr;
                }
            }
            // div:nth-child(1) {
            //     margin-right: 12px/$ppr;
            // }
            // div:nth-child(2) {
            //     margin-right: 11px/$ppr;
            // }
        }
        .disabled_btn {
            color: #666 !important;
        }
    }
}

.list {
    width: 100%;
    height: auto;
    margin-top: 25px / $ppr;
    .list_box {
        width: 100%;
        border-bottom: 1px / $ppr solid #e2e5ec;
        background: #fff;
        position: relative;
        .list_box-tips {
            width: 144px / $ppr;
            height: 66px / $ppr;
            background: url("../img/icon_img_title.png") no-repeat;
            background-size: 100% 100%;
            position: absolute;
            top: 50%;
            right: 20px / $ppr;
            transform: translate(0, -50%);
        }
        .list_title {
            width: 672px / $ppr;
            height: 96px / $ppr;
            margin: 0 auto;
            //font-weight:600;
            p:nth-child(1) {
                float: left;
                line-height: 96px / $ppr;
                font-size: 36px / $ppr;
                color: #333;
            }
            p:nth-child(2) {
                float: right;
                line-height: 96px / $ppr;
                font-size: 30px / $ppr;
                color: #5e89ef;
            }
        }
    }
    .lists {
        width: 100%;
        height: 96px / $ppr;
        border-bottom: 1px / $ppr solid #e2e5ec;
        background: #fff;
        div {
            width: 672px / $ppr;
            height: 96px / $ppr;
            margin: 0 auto;
            p {
                float: left;
                color: #333;
            }
            .name {
                width: 200px / $ppr;
                line-height: 96px / $ppr;
            }
            .score {
                width: 180px / $ppr;
                line-height: 96px / $ppr;
                text-align: center;
                margin-right: 24px / $ppr;
            }
            .upTime {
                width: 260px / $ppr;
                line-height: 96px / $ppr;
                text-align: center;
            }
        }
    }
    .lists1 {
        width: 100%;
        height: 96px / $ppr;
        border-bottom: 1px / $ppr solid #e2e5ec;
        background: #fff;
        div {
            width: 672px / $ppr;
            height: 96px / $ppr;
            margin: 0 auto;
            p {
                float: left;
                color: #999;
                font-size: 30px / $ppr;
            }
            p:nth-child(1) {
                width: 200px / $ppr;
                line-height: 96px / $ppr;
                position: relative;
                .user_name {
                    width: 150px / $ppr;
                    display: block;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
            p:nth-child(2) {
                width: 180px / $ppr;
                line-height: 96px / $ppr;
                text-align: center;
                margin-right: 24px / $ppr;
                position: relative;
                i {
                    color: #ff8042;
                    margin-right: 5px / $ppr;
                }
                .p_revision {
                    display: inline-block;
                    width: 41px / $ppr;
                    height: 28px / $ppr;
                    background: url("../../chinese/inspect/img/icon_img_03.png")
                        no-repeat;
                    background-size: 100% 100%;
                    position: absolute;
                    top: 34px / $ppr;
                }
            }
            p:nth-child(3) {
                width: 260px / $ppr;
                line-height: 96px / $ppr;
                span {
                    float: right;
                    width: 16px / $ppr;
                    height: 29px / $ppr;
                    margin-top: 34px / $ppr;
                    background: url(../img/icon_next.png) no-repeat;
                    background-size: 100%;
                }
            }
            .no {
                width: 260px / $ppr;
                text-align: center;
            }
        }
    }
    .lists1:last-child {
        border: 0;
    }
}

.tig-bu {
    position: absolute;
    top: 33px / $ppr;
    right: 0;
    width: 40px / $ppr;
    height: 30px / $ppr;
    line-height: 30px / $ppr;
    // padding: 1px 0;
    font-size: 24px / $ppr;
    color: #fff;
    background-color: #66cc22;
    // margin-left: 12px/$ppr;
    // line-height: normal;
    text-align: center;
    border-radius: 2px;
}

.noresources {
    width: 100%;
    height: 300px / $ppr;
    background-color: #fff;
    p {
        line-height: 300px / $ppr;
        text-align: center;
    }
}

.layui-m-layerchild {
    text-align: center;
}
.layui-m-layerchild {
    .layer-hd-title {
        color: #999;
    }
}
.textar {
    margin: auto 0;
    width: 86%;
    min-height: 200px / $ppr;
    margin: 30px / $ppr 0;
    margin-top: 0;
    background: #f0f0f0;
    border: none;
    padding: 20px / $ppr;
    border-bottom-left-radius: 10px / $ppr;
    border-bottom-right-radius: 10px / $ppr;

    font-size: 30px / $ppr;
}

.layui-m-layerbtn {
    border-top: 1px / $ppr solid #f0f0f0 !important;
    span {
        width: 50%;
        background: #fff;
    }
    span:nth-child(1) {
        border-right: 1px / $ppr solid #f0f0f0;
    }
    span:nth-child(2) {
        color: #5e89ef;
        border-right: 1px / $ppr solid #f0f0f0;
    }
}
</style>
